import constants from '../constants';
import { setDataAttributes } from '../../helpers';
import { EnrichmentConfig, EnrichmentElementDataAttribute, getEnrichmentData } from './getData';
import { Api } from '../../../../../typings/api';

const getEnrichmentParam = ({ isExternalLink, externalRelUrl, globalId }: Api.AspDriveResourceItemLight): string => {
	return isExternalLink ? externalRelUrl : globalId + '/';
};

const setElementContent = (
	htmlDocument: Document,
	id: string,
	resource: Api.AspDriveResourceItemLight,
	defaultResource: Api.AspDriveResourceItemLight,
): void => {
	const element = htmlDocument.querySelector(`#${id} [class*=${constants.enrichmentClassName}]`) as HTMLElement;

	// missing for a new-plugin enrichment, that one is saved to configs.json instead
	if (!element) {
		return;
	}

	const defaultRelUrl = defaultResource.isExternalLink
		? defaultResource.externalRelUrl
		: defaultResource.relUrl;
	const relUrl = resource.isExternalLink
		? resource.externalRelUrl
		: resource.relUrl;
	const isDefaultResource = relUrl === defaultRelUrl;
	const oldEnrichmentData = getEnrichmentData(element);

	if (!oldEnrichmentData) {
		return;
	}

	const { params } = oldEnrichmentData;
	const newResource = isDefaultResource ? defaultResource : resource;
	const newParam = getEnrichmentParam(newResource);
	params.param = newParam;
	params.assetDriveItem = newResource;

	const oldDataString = element.getAttribute('onclick') as string;
	const newDataString = oldDataString.replace(/"params":([\s\S]*?),"event"/, (match, group) => (
		match.replace(group, JSON.stringify(params))
	));

	element.setAttribute('onclick', newDataString);
	element.setAttribute('ontouchend', newDataString);

	if (isDefaultResource) {
		element.removeAttribute(EnrichmentElementDataAttribute.edited);
		element.removeAttribute(EnrichmentElementDataAttribute.defaultResource);
		element.removeAttribute(EnrichmentElementDataAttribute.deps);
	} else {
		setDataAttributes(element, {
			[EnrichmentElementDataAttribute.edited]: true,
			[EnrichmentElementDataAttribute.defaultResource]: JSON.stringify(defaultResource),
		});

		if (resource.deps) {
			element.setAttribute(EnrichmentElementDataAttribute.deps, resource.deps);
		} else {
			element.removeAttribute(EnrichmentElementDataAttribute.deps);
		}
	}
};

export default (htmlDocument: Document, items: EnrichmentConfig[]): void => {
	items.forEach(({
		isEditedFromBackoffice,
		id,
		resource,
		defaultResource,
	}) => {
		if (!isEditedFromBackoffice) {
			return;
		}

		setElementContent(htmlDocument, id, resource, defaultResource);
	});
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/utils/indesignEditor/editableEnrichments/saveData.ts